export const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "32%",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.8)",
  },
};

export const customStylesReview = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "25%",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.8)",
  },
};

export const customStylesSlide = {
  content: {
    // top: "50%",
    // left: "50%",
    // right: "auto",
    // bottom: "auto",
    // marginRight: "-50%",
    // transform: "translate(-50%, -50%)",
    // width: "1142px",
    overflow: "hidden",
    // border: "none",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.8)",
  },
};
